export enum ManageRole {
  assign = 'assign',
  detach = 'detach',
}
